import { parse } from "@evidenceb/athena-common/modules/HTMLParser";
import React, { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import CustomSelect from "../../../../../../../design-system-components/CustomSelect/CustomSelect";
import { DuoParticipant } from "../../../../Duo.types";
import { DuoConstruction } from "../AddDuoModal";
import { fullName } from "../../../../../../../utils/format";

import "./DefineRoles.scss";

type Props = {
    duo: DuoConstruction;
    setDuo: Dispatch<
        SetStateAction<{
            mentor?: DuoParticipant;
            mentee?: DuoParticipant;
        }>
    >;
};

const DefineRoles = ({ duo, setDuo }: Props) => {
    const intl = useIntl();

    const { mentor, mentee } = duo;

    const firstSelectRef = useRef<HTMLSelectElement>(null);
    // focus first select on render
    useEffect(() => {
        if (!firstSelectRef.current) return;
        firstSelectRef.current.focus();
    }, []);

    const handleSelectOption =
        (type: "mentor" | "mentee") => (value: string) => {
            if (fullName(duo[type]!) === value) return;
            setDuo((duo) => ({
                ...duo,
                mentor: mentee,
                mentee: mentor,
            }));
        };

    return (
        <div className="define-roles__container">
            <p>{parse(intl.formatMessage(messages.player1Explanation))}</p>
            <CustomSelect
                ref={firstSelectRef}
                variant="label-on-border"
                onSelectOption={handleSelectOption("mentee")}
                label={intl.formatMessage(messages.player1)}
                selectedOptionLabel={mentee ? fullName(mentee) : "none"}
                selectedOptionValue={mentee ? fullName(mentee) : "none"}
                iconProps={{
                    path: "chevron_down",
                    size: "large",
                    color: "var(--element-teacher-default)",
                }}
                color="var(--element-teacher-default)"
                className="define-roles__select"
            >
                {[mentee!, mentor!].map((participant) => (
                    <option
                        key={fullName(participant)}
                        value={fullName(participant)}
                    >
                        {fullName(participant)}
                    </option>
                ))}
            </CustomSelect>

            <p>{parse(intl.formatMessage(messages.player2Explanation))}</p>
            <CustomSelect
                variant="label-on-border"
                onSelectOption={handleSelectOption("mentor")}
                label={intl.formatMessage(messages.player2)}
                selectedOptionLabel={fullName(mentor!)}
                selectedOptionValue={fullName(mentor!)}
                iconProps={{
                    path: "chevron_down",
                    size: "large",
                    color: "var(--element-teacher-default)",
                }}
                color="var(--element-teacher-default)"
                className="define-roles__select"
            >
                {[mentee!, mentor!].map((participant) => (
                    <option
                        key={fullName(participant)}
                        value={fullName(participant)}
                    >
                        {fullName(participant)}
                    </option>
                ))}
            </CustomSelect>
        </div>
    );
};
export default DefineRoles;

const messages = defineMessages({
    player1Explanation: {
        id: "html-workmode-duo-player1Explanation",
        defaultMessage:
            "<b>Player 1</b>: They are the only one who can submit an exercise's answer.",
    },
    player1: {
        id: "workmode-duo-player1",
        defaultMessage: "Player 1",
    },
    player2Explanation: {
        id: "html-workmode-duo-player2Explanation",
        defaultMessage:
            "<b>Player 2</b>: They can interact with the exercise but cannot submit their answer. Their role is to support the other player.  ",
    },
    player2: {
        id: "workmode-duo-player2",
        defaultMessage: "Player 2",
    },
});
